import apolloClient from 'graphql/apolloClient';
import { handleGraphQLErrors } from 'services/ErrorService/ErrorService';

// ⚠️ fetchPolicy: 'no-cache'
//
// Apollo Client’s caching can be surprising: by default every response is
// written to its in-memory store—even if you disable cache layers in the global
// config.  In our experience that leads to bloated memory footprints.

const subscribeToLiveQuery = (query, variables, dataFieldName, onDataReceived) => {
  const subscription = apolloClient
    .subscribe({
      query,
      variables: { input: variables },
      fetchPolicy: 'no-cache',
    })
    .subscribe(
      (result) => {
        const payload = result.data?.[dataFieldName];
        if (!payload) {
          return;
        }

        onDataReceived(payload);
      },
      (error) => {
        handleGraphQLErrors(error);
        subscription?.unsubscribe();
      }
    );

  return subscription;
};

export default subscribeToLiveQuery;
